module.exports = {"230705001":"西林街道","230705003":"新兴街道","230705005":"苔青街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230705.json
// module id = 686
// module chunks = 0